import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAllMachines() {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: '/machines/getAllMachines'
      }))
  );
}

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/machines?accountID=${accountID}`
      }))
  );
}

async function getById(machineID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/machines/${machineID}`
      }))
  );
}

async function create(machine) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/machines',
        body: JSON.stringify(machine)
      }))
  );
}

async function update(machine) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/machines/${machine.machineID}`,
        body: JSON.stringify(machine)
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(machineID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/machines/${machineID}`
      }))
  );
}

async function revokeDeviceAccess(deviceID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: `/devices/revokedeviceaccess/${deviceID}`
      }))
  );
}

const machineService = {
  getAllMachines,
  getAll,
  getById,
  create,
  update,
  delete: Delete,
  revokeDeviceAccess
};

export default machineService;
